import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { PageHeader } from "@/components/PageHeader";
import { Section, SectionHeading, Reveal } from "@/components/primitives";
import { trackEvent } from "@/lib/api";
import { ArrowRight, Crown, Presentation, VideoCamera, ChalkboardTeacher, Handshake, Buildings } from "@phosphor-icons/react";

const SUPPORT = [
  { icon: Crown, title: "Company-Funded Leadership Accounts", desc: "Support structures for qualified strategic leaders." },
  { icon: Presentation, title: "Marketing Resources", desc: "Approved corporate materials and presentations." },
  { icon: Buildings, title: "Corporate Presentations", desc: "Executive-level product and technology presentations." },
  { icon: VideoCamera, title: "Leadership Webinars", desc: "Regular webinars for global business builders." },
  { icon: ChalkboardTeacher, title: "Training", desc: "Structured training on the technology and platform." },
  { icon: Handshake, title: "Executive Access & Event Support", desc: "Approved event support and executive access." },
];

export default function Leadership() {
  useEffect(() => {
    trackEvent("page_view", { page: "leadership" });
  }, []);
  return (
    <div>
      <PageHeader
        eyebrow="Global Leadership Program"
        title="For experienced business builders and strategic leaders."
        sub="Quantum Scalp works with experienced leaders to expand internationally. All incentive structures are configurable and subject to the official program terms."
      />

      <Section grid>
        <SectionHeading eyebrow="Program Support" title="Potential support for leaders." className="mb-12" />
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {SUPPORT.map((s, i) => (
            <Reveal key={s.title} delay={(i % 3) * 0.05}>
              <div className="h-full rounded-xl border border-white/10 bg-[#0A0B10] p-6">
                <span className="grid place-items-center h-11 w-11 rounded-lg border border-[#0E9E90]/30 bg-[#0E9E90]/10 text-[#a5b0f5] mb-4">
                  <s.icon size={22} weight="duotone" />
                </span>
                <h3 className="text-base font-bold text-white mb-1.5">{s.title}</h3>
                <p className="text-sm text-[#94A3B8]">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </Section>

      <Section>
        <div className="rounded-2xl border border-white/10 bg-[#0A0B10] p-8 md:p-12 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="text-2xl font-black text-white">Apply for the Leadership Program.</h3>
            <p className="text-[#94A3B8] mt-2">Select "Leadership" or "Master Distributor" on the partner application.</p>
          </div>
          <Link to="/partners" className="shrink-0 inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-[#2DD4BF] text-[#030305] font-semibold hover:bg-white transition-colors" data-testid="leadership-apply">
            Apply Now <ArrowRight size={16} weight="bold" />
          </Link>
        </div>
      </Section>
    </div>
  );
}
